export default __webpack_public_path__ + "static/media/elevate-pyl-banner-2.7bccfc2c.jpg";